import React, { memo } from 'react';
export function ProblemSection() {
  return <section className="w-full bg-white py-16 md:py-20 px-4" data-id="element-263">
      <div className="max-w-3xl mx-auto" data-id="element-264">
        {/* Opening Question */}
        <div className="text-center mb-12" data-id="element-265">
          <p className="font-body text-lg md:text-xl text-gray-700 mb-6" data-id="element-266">
            Si te interesa el Tarot, dejame hacerte una pregunta honesta…
          </p>

          <h2 className="font-heading font-bold text-2xl md:text-4xl text-gray-900 leading-tight mb-8" data-id="element-267">
            ¿Te pasa que sentís curiosidad por las cartas pero no sabés por
            dónde empezar?
          </h2>

          <div className="space-y-4 text-left max-w-2xl mx-auto font-body text-gray-700 text-base md:text-lg leading-relaxed" data-id="element-268">
            <p data-id="element-269">No porque no tengas intuición.</p>
            <p data-id="element-270">No porque no sea para vos.</p>
            <p className="font-semibold text-gray-900" data-id="element-271">
              Sino porque nadie te explicó el Tarot de forma simple y aplicable
              a tu vida.
            </p>
            <p className="mt-6" data-id="element-272">
              Probás aprender…
              <br data-id="element-273" />
              Te encontrás con información confusa.
              <br data-id="element-274" />
              Significados sueltos que no conectan entre sí.
            </p>
            <p className="mt-4" data-id="element-275">
              Y terminás pensando:
              <br data-id="element-276" />
              <span className="italic text-gold-600 font-semibold" data-id="element-277">
                "Ojalá alguien me lo explicara fácil…"
              </span>
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="w-24 h-1 bg-gold-500 mx-auto my-12" data-id="element-278" />

        {/* The Real Problem */}
        <div className="text-center" data-id="element-279">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-gray-900 mb-4" data-id="element-280">
            🔮 Aprender Tarot no debería sentirse así
          </h2>

          <p className="font-body text-base md:text-lg text-gray-700 mb-4" data-id="element-281">
            El problema que nadie dice es este:
          </p>

          <p className="font-heading font-bold text-xl md:text-2xl text-urgency-600 mb-8" data-id="element-282">
            👉 No es que el Tarot sea difícil… es que está mal explicado.
          </p>

          <p className="font-body text-base md:text-lg text-gray-700 mb-6" data-id="element-283">
            Si esto te pasa, no estás solo:
          </p>

          <div className="text-left max-w-xl mx-auto space-y-3 mb-10" data-id="element-284">
            <p className="font-body text-base md:text-lg text-gray-800 flex items-start gap-3" data-id="element-285">
              <span className="text-urgency-500 font-bold text-xl leading-none mt-0.5" data-id="element-286">
                ●
              </span>
              <span data-id="element-287">No entendés bien los significados de las cartas</span>
            </p>
            <p className="font-body text-base md:text-lg text-gray-800 flex items-start gap-3" data-id="element-288">
              <span className="text-urgency-500 font-bold text-xl leading-none mt-0.5" data-id="element-289">
                ●
              </span>
              <span data-id="element-290">Te cuesta conectar la teoría con la práctica</span>
            </p>
            <p className="font-body text-base md:text-lg text-gray-800 flex items-start gap-3" data-id="element-291">
              <span className="text-urgency-500 font-bold text-xl leading-none mt-0.5" data-id="element-292">
                ●
              </span>
              <span data-id="element-293">Sentís que necesitás memorizar todo</span>
            </p>
            <p className="font-body text-base md:text-lg text-gray-800 flex items-start gap-3" data-id="element-294">
              <span className="text-urgency-500 font-bold text-xl leading-none mt-0.5" data-id="element-295">
                ●
              </span>
              <span data-id="element-296">No sabés cómo hacer tiradas correctamente</span>
            </p>
            <p className="font-body text-base md:text-lg text-gray-800 flex items-start gap-3" data-id="element-297">
              <span className="text-urgency-500 font-bold text-xl leading-none mt-0.5" data-id="element-298">
                ●
              </span>
              <span data-id="element-299">Dudás de tu interpretación</span>
            </p>
          </div>

          <p className="font-body text-lg md:text-xl text-gray-900 font-semibold" data-id="element-300">
            Lo peor no es no saber.
            <br data-id="element-301" />
            <span className="text-urgency-600" data-id="element-302">
              Es sentir que nunca vas a poder aprender de verdad.
            </span>
          </p>
        </div>
      </div>
    </section>;
}